/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-lines-per-function */
/**
 * @file  Events
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect, useState, useContext} from 'react';
import {Select, Input, Col, message, Pagination, Divider} from 'antd';
import {Picker} from 'antd-mobile';
import EventsItem from '~/component/EventsItem';
import IconFont from '~/component/Iconfont';
import {renderSelectOptions} from '~/utils/render';
import {yearSection} from '~/utils/function';
import {yearSelect, pageSection} from '~/utils/common';
import {getListByChannelCode} from '~/service/cms';
import {BasicLayoutContext} from '~/layout/BasicLayout';
import './index.less';

function Events() {
    const [keyword, setKeyword] = useState('');
    const [total, setTotal] = useState(0);
    const [yearMobile, setYearMobile] = useState([]);
    const [channelIrEvents, setChannelIrEvents] = useState([]);
    const [channelPastEvents, setChannelPastEvents] = useState([]);
    const [pageNumMobile, setPageNumMobile] = useState([]);
    const [irPageDto, setIrPageDto] = useState({
        pageNum: 1,
        pageSize: 10
    });
    const [pageDto, setPageDto] = useState({
        pageNum: 1,
        pageSize: 10
    });
    const {pageNum} = pageDto;
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    function getUpcomingEvents() {
        getListByChannelCode({code: 'channel_ir_events', pageDto: irPageDto})
            .then(({data}) => {
                const {list} = data;
                setChannelIrEvents(list);
            })
            .catch(() => {
                message.error('获取即将发生的事失败');
            });
    }

    function getPastEvents() {
        getListByChannelCode({code: 'ir_past_events', pageDto, keyword})
            .then(({data}) => {
                const {list, total} = data;
                setChannelPastEvents(list);
                setTotal(total);
            })
            .catch(() => {
                message.error('获取过去的事失败');
            });
    }

    function handlePageChange(page, pageSize) {
        setPageDto({
            pageNum: page,
            pageSize
        });
    }

    useEffect(() => {
        getUpcomingEvents();
    }, []);

    useEffect(() => {
        getPastEvents();
    }, [pageDto, keyword]);


    function handleMenuClick(value) {
        if (isMobile) {
            setKeyword(value[0]);
            setYearMobile(value);
        }
        else {
            setKeyword(value);
        }
        setPageDto({
            pageNum: 1,
            pageSize: 10
        });
    }

    function handlePageChangeMobile(value) {
        setPageDto({
            pageNum: value[0],
            pageSize: 10
        });
        setPageNumMobile(value);
    }

    /**
     * 处理分页数据
     */
    const pageSelect = [];
    pageSelect.push(pageSection(total, 10));

    return (
        <div className="events-content">
            {
                isMobile && (
                    <>
                        <div className="events-content-title">
                            Events
                        </div>
                        <Divider />
                    </>
                )
            }
            {
                !!channelIrEvents.length && (
                    <div className="upcoming">

                        {
                            isMobile
                                ? (
                                    <>
                                        <div className="upcoming-events-title">
                                            <div className="upcoming-title"></div>
                                            <span className="upcoming-events">UPCOMING EVENTS</span>
                                        </div>
                                        <Divider />
                                    </>
                                )
                                : (
                                    <span className="upcoming-events">UPCOMING EVENTS</span>
                                )
                        }

                        {
                            channelIrEvents.map(item => (
                                <Col span={12} key={item.id}>
                                    <EventsItem
                                        item={item}
                                        type="upcoming-event"
                                    />
                                </Col>
                            ))
                        }
                    </div>
                )
            }


            <div className="past">
                <div className="past-search">
                    {
                        isMobile
                            ? (
                                <>
                                    <div className="upcoming-events-title">
                                        <div className="upcoming-title"></div>
                                        <span className="past-events">PAST EVENTS</span>
                                    </div>
                                    <Divider />
                                    <div className="past-content-year-filter">
                                        filter
                                        <Picker
                                            data={yearSelect}
                                            cascade={false}
                                            okText="determine"
                                            dismissText="cancel"
                                            value={yearMobile}
                                            onChange={handleMenuClick}
                                        >
                                            <div className="past-content-year">
                                                {
                                                    yearMobile.length === 0 || yearMobile[0] === ''
                                                        ? 'All Year'
                                                        : keyword
                                                }
                                                <IconFont type="iconxiala" className="iconxiala" />
                                            </div>
                                        </Picker>
                                    </div>
                                    <Divider />
                                </>
                            )
                            : (
                                <>
                                    <span className="past-events">PAST EVENTS</span>
                                    <Select
                                        defaultValue=""
                                        onChange={handleMenuClick}
                                    >
                                        {renderSelectOptions(yearSection())}
                                    </Select>
                                </>
                            )
                    }

                    {
                        total === 0 && (
                            <div className="iconweikong-img">
                                <IconFont type="iconweikong" className="iconweikong" />
                                <div className="weikong-text">No Past Event</div>
                            </div>
                        )
                    }
                </div>

                {!!channelPastEvents
                    && channelPastEvents.map(item => (
                        <Col span={12} key={item.id}>
                            <EventsItem
                                item={item}
                                type="past-event"
                            />
                        </Col>
                    ))
                }

                {
                    isMobile
                        ? (
                            <>
                                <div className="past-content-year-filter">
                                    PaginationShow
                                    <Picker
                                        data={pageSelect}
                                        cascade={false}
                                        okText="determine"
                                        dismissText="cancel"
                                        value={pageNumMobile}
                                        onChange={handlePageChangeMobile}
                                    >
                                        <div className="releases-content-year">
                                            {pageNum}
                                            <IconFont type="iconxiala" className="iconxiala" />
                                        </div>
                                    </Picker>
                                </div>

                                <Divider />
                            </>
                        )
                        : (
                            <div className="past-pagination">
                                <Pagination
                                    onChange={handlePageChange}
                                    defaultPageSize={10}
                                    defaultCurrent={1}
                                    total={total}
                                    current={pageNum}
                                    showSizeChanger
                                    hideOnSinglePage
                                />
                            </div>
                        )
                }
            </div>
        </div>
    );
}

export default Events;
